import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "@/components/auth/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { LoginPage } from "@/pages/auth/LoginPage";
import { TotpChallengePage } from "@/pages/auth/TotpChallengePage";
import { TotpEnrollPage } from "@/pages/auth/TotpEnrollPage";
import { SessionExpiredPage } from "@/pages/auth/SessionExpiredPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { AppStatusPage } from "@/pages/AppStatusPage";
import { FeatureFlagsPage } from "@/pages/FeatureFlagsPage";
import { HomeBlocksPage } from "@/pages/HomeBlocksPage";
import { DailyContentPage } from "@/pages/DailyContentPage";
import { NotificationsPage } from "@/pages/NotificationsPage";
import { VersionsPage } from "@/pages/VersionsPage";
import { AuditPage } from "@/pages/AuditPage";
import { SecurityPage } from "@/pages/SecurityPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/totp" element={<TotpChallengePage />} />
      <Route path="/login/enroll" element={<TotpEnrollPage />} />
      <Route path="/session-expired" element={<SessionExpiredPage />} />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="/app-status" element={<AppStatusPage />} />
        <Route path="/features" element={<FeatureFlagsPage />} />
        <Route path="/home-blocks" element={<HomeBlocksPage />} />
        <Route path="/daily-content" element={<DailyContentPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/versions" element={<VersionsPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/security" element={<SecurityPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
